import { render } from "./Notices.vue?vue&type=template&id=4d5a2fe4&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"

import "./Notices.vue?vue&type=style&index=0&id=4d5a2fe4&scoped=true&lang=css"
import "./Notices.vue?vue&type=style&index=1&id=4d5a2fe4&lang=css"
import "./Notices.vue?vue&type=style&index=2&id=4d5a2fe4&scoped=true&lang=css"
import "./Notices.vue?vue&type=style&index=3&id=4d5a2fe4&lang=css"
import "./Notices.vue?vue&type=style&index=4&id=4d5a2fe4&lang=css"
import "./Notices.vue?vue&type=style&index=5&id=4d5a2fe4&scoped=true&lang=css"
import "./Notices.vue?vue&type=style&index=6&id=4d5a2fe4&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5a2fe4"]])

export default __exports__